import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import initialState from "../initial-state";

const buttons = createSlice({
  name: "buttons",
  initialState: initialState.buttons,
  reducers: {
    toggleButtons(state, action) {
      if (!action.payload) return state;
      const newState = Object.keys(action.payload).reduce((obj: any, name) => {
        //@ts-ignore
        const button = state[name];
        const disabled = !action.payload[name];
        if (!button || disabled === button.disabled) return obj;

        if (button.hidden) {
          obj[name] = {
            ...button,
            disabled: !action.payload[name],
            hidden: !action.payload[name],
          };
        } else {
          obj[name] = { ...button, disabled: !action.payload[name] };
        }

        return obj;
      }, {});

      return { ...state, ...newState };
    },
    toggleButtonsVisibility(state, action) {
      if (!action.payload) return state;
      const newState = Object.keys(action.payload).reduce((obj: any, name) => {
        //@ts-ignore
        const button = state[name];
        const hidden = !action.payload[name];

        if (!button || hidden === button.hidden) return obj;

        obj[name] = { ...button, hidden };

        return obj;
      }, {});

      return { ...state, ...newState };
    },

    toggleButtonsAvailability(state, action) {
      if (!action.payload) return state;
      const newState = Object.keys(action.payload).reduce((obj: any, name) => {
        //@ts-ignore
        const button = state[name];
        const available = action.payload[name];

        obj[name] = { ...button, available };

        return obj;
      }, {});

      return { ...state, ...newState };
    },

    setButtonType(
      state,
      action: PayloadAction<{ button: keyof ButtonsState; type: string }>
    ) {
      if (!state[action.payload.button]) return state;
      const { button, type } = action.payload;

      return { ...state, [button]: { ...state[button], type } };
    },

    setButtonLock(
      state,
      action: PayloadAction<{
        button: keyof ButtonsState;
        progress: number;
        timestamp?: number;
      }>
    ) {
      if (!state[action.payload.button]) return state;
      const { button, progress, timestamp } = action.payload;
      const l = (state[button] as FullButtonsState).locked ?? {};
      const locked = {
        ...l,
        progress: Math.min(progress, 1),
        // if the timestamp is changed that means a new lock cycle had been started
        timestamp: timestamp ?? l.timestamp,
      };

      return { ...state, [button]: { ...state[button], locked } };
    },
  },
});

type ButtonsState = typeof initialState.buttons;
type FullButtonsState = typeof initialState.buttons.spin;

export const selectButton = <Name extends keyof ButtonsState>(
  name: Name,
  state: RootState
) => state.buttons[name];

export const {
  toggleButtons,
  toggleButtonsVisibility,
  toggleButtonsAvailability,
  setButtonType,
  setButtonLock,
} = buttons.actions;

export default buttons;
